import { Injectable } from '@angular/core';
import { ApiService } from './api.service';
import { Observable } from 'rxjs';
import { ProjectPool } from '../models/project-pool';
import { Candidate } from '../models/candidate';
import { TalentPool } from 'mojo-talent-pools';
import { Pagination } from '../models/pagination';
import { GetLikedCandidatesRequestBody } from '../models/get-liked-candidates-request-body';
import { DeleteCandidateFromTheProjectRequestBody } from '../models/delete-candidate-from-the-project-request-body';

@Injectable({
  providedIn: 'root',
})
export class ProjectsService extends ApiService {
  constructor() {
    super();
    this.url = 'projects/';
  }

  getProjectCandidates(
    statusId: number | null,
    projectId: number,
    page = 0,
  ): Observable<Pagination<Candidate>> {
    return this.post<GetLikedCandidatesRequestBody, Pagination<Candidate>>({
      url: `${projectId}/candidates`,
      body: {
        statusId,
        projectId,
      },
      params: {
        page,
      },
    });
  }

  deleteCandidatesFromTheProject(projectId: number, candidateIds: string[]): Observable<void> {
    return this.delete<DeleteCandidateFromTheProjectRequestBody, void>({
      url: `${projectId}/candidates`,
      body: {
        talentPoolId: projectId,
        externalSourcingIds: candidateIds,
      },
    });
  }
  getProjectsAll(): Observable<ProjectPool[]> {
    return this.get({ url: '' });
  }

  updateProject(project: ProjectPool): Observable<ProjectPool> {
    return this.patch<ProjectPool, ProjectPool>({ url: `${project.talentPool.id}`, body: project });
  }

  addCandidateToProject(
    projectId: number,
    candidateId: string,
    summary?: string,
  ): Observable<void> {
    const body: {
      talentPoolIds: number[];
      candidateIds: string[];
      summaryMap?: Record<string, string>;
    } = {
      talentPoolIds: [projectId],
      candidateIds: [candidateId],
    };
    if (summary) {
      body.summaryMap = { [`${candidateId}-${projectId}`]: summary };
    }
    return this.post<typeof body, void>({ url: `candidates`, body });
  }

  deleteProject(projectId: number) {
    return this.delete<number, void>({
      url: `${projectId}`,
    });
  }

  createProject(
    candidateIds: Partial<Candidate>[],
    talentPool: Partial<TalentPool>,
  ): Observable<ProjectPool> {
    const dataToSend = {
      talentPool,
      candidates: candidateIds,
    };
    return this.post({ url: '', body: dataToSend });
  }

  changeProjectExternalCandidateStatus(
    talentPoolId: number,
    candidateId: string,
    body: { status: string | null } | null,
  ): Observable<Candidate> {
    return this.patch({
      url: `${talentPoolId}/candidates/${candidateId}/status`,
      body,
    });
  }
}
